"use client";

import { SubMenu } from "./ui/SubMenu";
import { SubMenuLink } from "./ui/SubMenuLink";
import { MenuLogo } from "./ui/MenuLogo";
import { useUIStore } from "@/store/ui/ui-store";
import "./Menu.css";
import { UserMenu } from "./ui/UserMenu";
import { TbLayoutSidebarLeftCollapse, TbLayoutSidebarLeftExpand } from "react-icons/tb";

export const LeftMenu = ({ dataMenu, homeHref }: any) => {

    const isSideMenuOpen = useUIStore((state) => state.isSideMenuOpen);
    const isCollapsed = useUIStore((state) => state.isSideMenuCollapsed);
    const toggleCollapsed = useUIStore((state) => state.toggleSideMenuCollapsed);

    const mainMenu = dataMenu?.mainMenu ?? [];
    const settingsMenu = dataMenu?.settingsMenu ?? [];

    const renderItem = (main: any) =>
        main?.tagSubMenu ? (
            <SubMenu
                key={main.id}
                label={main.label}
                subMenu={main.subMenu}
                icons={main.icon}
                collapsed={isCollapsed}
            />
        ) : (
            <SubMenuLink
                key={main.id}
                icons={main.icon}
                label={main.label}
                link={main.link}
                collapsed={isCollapsed}
            />
        );

    return (
        <aside
            data-collapsed={isCollapsed}
            className={`app-sidebar ${isSideMenuOpen ? "translate-x-0" : "-translate-x-full"}`}
        >
            <div className="app-sidebar__scroll">
                <div className={`flex flex-col gap-1 ${isCollapsed ? "p-2 lg:items-center" : "p-4"}`}>
                    <div className="flex items-center justify-between gap-2">
                        <MenuLogo href={homeHref} collapsed={isCollapsed} />
                        <button
                            type="button"
                            onClick={toggleCollapsed}
                            aria-label={isCollapsed ? "Expandir menú" : "Contraer menú"}
                            title={isCollapsed ? "Expandir menú" : "Contraer menú"}
                            className="hidden lg:grid place-items-center rounded-md p-1.5 text-[var(--nav-fg)] hover:bg-[var(--nav-hover-bg)] hover:text-[var(--nav-fg-strong)] motion-reduce:transition-none transition-colors"
                        >
                            {isCollapsed ? (
                                <TbLayoutSidebarLeftExpand size={18} />
                            ) : (
                                <TbLayoutSidebarLeftCollapse size={18} />
                            )}
                        </button>
                    </div>

                    <nav className="mt-2 flex flex-col gap-0.5">
                        {mainMenu.map(renderItem)}

                        {settingsMenu.length > 0 && (
                            <div
                                className={`my-2 border-t border-[var(--nav-border)] ${isCollapsed ? "mx-1" : ""}`}
                            />
                        )}

                        {settingsMenu.map(renderItem)}
                    </nav>
                </div>
            </div>

            <div className="shrink-0 border-t border-[var(--nav-border)] p-2">
                <UserMenu collapsed={isCollapsed} />
            </div>
        </aside>
    );
};
